module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo20-da5c6e96f83f040eb3e76f90f58affc9.jpg";